import { React, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Pagination from "../../Controls/Pagination/pagination";
import { AiOutlineCloseCircle } from "react-icons/ai";

import APIRequest from "../../../Services/commonAPIConsumer";
import {
  languageChange,
  currentSelectedLanguage,
} from "../../../StateManagement/actions";
import LoadingSpinner from "../../Controls/Spinner/LoadingSpinner";
import Alert from "../../Controls/Alerts/Alerts";

let isInitialRenderOfComponent = true;
function UserListPopup({
  isOpen,
  onCancel,
  sendDataToParent,
  sendDataListToParaent,
  folderID,
  sharingOption,
  isEditUsersOfFolder
}) {
  const history = useNavigate();
  const viewRef = useRef([]);
  const editRef = useRef([]);
  const selectAllUserRef = useRef(null);
  const selectAccessRef = useRef(null);

  const userList = useRef([]);
  const isEditUsers = useRef(false);

  const dispatch = useDispatch();
  let userCurrentPagevalue = 1;
  let userCurrentPageViewCount = 25;
  let firsttimecall = 0;
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const [currentPage, setCurrentPage] = useState(1);
  const [usertotalPagesCount, setUserTotalPagesCount] = useState(0);
  const [userPageView, setUserPageView] = useState(25);
  const [isUserDisablePrev, setisUserDisablePrev] = useState(false);
  const [isUserDisableNext, setisUserDisableNext] = useState(false);
  const [lstUserDetails, setLstUserDetails] = useState([]);
  const [userMasterSelection, setUserMasterSelection] = useState(false);
  const [ownerInput, setOwnerInput] = useState("");
  const [noRecordsFoundUsers, setNoRecordsFoundUsers] = useState(false);
  const [openLoader, setOpen] = useState(true);
  const [openLoaderSearch, setOpenLoaderSearch] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [selectedSearchRecords, setSelectedSearchRecords] = useState([
    {
      page: 0,
      users: [],
    },
  ]);
  const isMasterSelection = useRef(false);
  const itemsCheckRef = useRef([]);
  const [isControlClick, setIsControlClick] = useState({
    isSearchOrRefresh: false,
    isClear: false,
    isSharedUsers: false,
  });
  const [recordsSelectedCount, setRecordsSelectedCount] = useState({
    showRecords: false,
    count: 0,
  });
  const paginationAttributes = {
    currentPage,
    totalPages: usertotalPagesCount,
    DisableNext: isUserDisableNext,
    DisablePrev: isUserDisablePrev,
  };
  const borderleft = {
    borderLeft: "0.1rem solid #e7e5e570",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };
  const isrPDSharedFolderDataSharedUserIds = useRef(false);
  const rPDSharedFolderDataSharedUserIds = useRef([]);
  const isRpdSelectedTextClear = useRef(false);


  const [accessRecords, setAccessRecords] = useState({
    view: [],
    edit: [],
  });
  // const { editRecords } = props;



  useEffect(() => {
    setAlertType("");
    setCurrentPage(1);
    userCurrentPagevalue = 1;
    firsttimecall = 1;
    setOwnerInput("");
    isEditUsers.current = isEditUsersOfFolder;
    GetUserList();
  }, []);

  useEffect(() => {
    console.log(`effect runs`);
    if (isControlClick.isClear) {
      GetUserList(1);
    }
    if (isControlClick.isSearchOrRefresh) {
      GetUserList();
    }
    if (isControlClick.isSharedUsers) {
      selectionOfRecords();
    }
  }, [isControlClick]);



  useEffect(() => {
    if (isInitialRenderOfComponent) {
      isInitialRenderOfComponent = false;
      return;
    }
    let totalDocsCount = 0;
    const allDocs = selectedSearchRecords.reduce((accumulator, item) => {
      return accumulator.concat(item.users);
    }, []);

    totalDocsCount = allDocs.length; //allSelectedDocs.length + allSearchSelectedDocs.length;
    console.log(totalDocsCount);
    if (sharingOption === "2") {
      return;
    }
    setRecordsSelectedCount((prev) => {
      return {
        showRecords: totalDocsCount != 0 ? true : false,
        count: totalDocsCount,
      };
    });
  }, [selectedSearchRecords]);


  const GetUserList = async (iscleared = 0) => {
    setOpen(true);
    try {
      var url = `${process.env.REACT_APP_API + process.env.REACT_APP_API_UserSearch
        }`;
      var jsonDocs = await APIRequest.GET(
        "",
        url +
        "?userName=" +
        (iscleared == 0 ? (firsttimecall == 1 ? "" : ownerInput) : "") +
        "&folderID=" +
        folderID +
        "&currentPage=" +
        userCurrentPagevalue +
        "&pageSize=" +
        userCurrentPageViewCount
      );
      if (jsonDocs && jsonDocs === "Server maintenance") {
        history("/maintenance");
        return;
      } else if (
        jsonDocs.errorMessage != undefined &&
        jsonDocs.errorMessage != ""
      ) {
        setOpen(false);
        setAlertMsg(jsonDocs.errorMessage);
        setAlertType("warning");
        return;
      }
      //setUserTotalPagesCount(jsonDocs.totalCount);
      if (jsonDocs.userList.length <= 0) {
        if (userCurrentPagevalue == 1) {
          setNoRecordsFoundUsers(true);
          setUserMasterSelection(false);
        } else if (userCurrentPagevalue > 1) {
          setCurrentPage(1);
          userCurrentPagevalue = 1;
          GetUserList();
        }
      } else {
        setNoRecordsFoundUsers(false);
      }

      const allUsers = selectedSearchRecords.reduce((accumulator, item) => {
        return accumulator.concat(item.users);
      }, []);

      let recordCount = 0;
      if (jsonDocs.rPDSharedFolderData == null) {
        if (sharingOption === "2") {
          jsonDocs.userList.map((item, i) => {
            item.selection = true;
            recordCount++;
          });
          setSelectedSearchRecords((prev) => {
            const existingPage = prev.find((record) => record.page === 0);
            if (existingPage) {
              const userIds = jsonDocs.userList.map((item) => item.id);
              return prev.map((record) => record.page === 0 ? { ...record, users: [...existingPage.users, ...userIds] } : record)
            }
          })
        } else {
          jsonDocs.userList.map((item, i) => {
            if (allUsers && allUsers.includes(item.id)) {
              item.selection = true;
              recordCount++;
            } else {
              item.selection = false;
            }
          });
        }
        if (
          jsonDocs.userList.length != 0 &&
          recordCount === jsonDocs.userList.length
        ) {
          setUserMasterSelection(true);
        } else {
          setUserMasterSelection(false);
          isMasterSelection.current = false;
        }
        sendDataListToParaent([]);
      } else {
        var Userids = [];
        if (jsonDocs.rPDSharedFolderData.sharedUserIds.length > 0) {
          if (!isRpdSelectedTextClear.current) {
            jsonDocs.rPDSharedFolderData.sharedUserIds.map(
              (itemUserList, i) => {
                Userids.push(itemUserList.sharedUserId);
              }
            );
            isrPDSharedFolderDataSharedUserIds.current = true;
            rPDSharedFolderDataSharedUserIds.current = [...Userids];
          }
          jsonDocs.userList.map((item, i) => {
            item.selection =
              Userids.length > 0 && Userids.includes(item.id) ? true : false;
          });

          if (isEditUsers.current) {
            let editRecords = [];
            let viewRecords = [];
            jsonDocs.rPDSharedFolderData.sharedUserIds.map((item, i) => {
              if (item.isEdit == 1) {
                editRecords.push(item.sharedUserId);
              } else {
                viewRecords.push(item.sharedUserId);
              }
            });
            setAccessRecords({ edit: editRecords, view: viewRecords });
            isEditUsers.current = false;
          }
          if (sharingOption === "2") {
            jsonDocs.userList.map((item, i) => {
              item.selection = true;
              recordCount++;
            });
          }

          else {
            if (allUsers && allUsers.length > 0) {
              jsonDocs.userList.map((item, i) => {
                if (allUsers.includes(item.id)) {
                  item.selection = true;
                  recordCount++;
                } else {
                  item.selection = false;
                }
              });
            }
          }
          if (
            jsonDocs.userList.length != 0 &&
            recordCount === jsonDocs.userList.length
          ) {
            setUserMasterSelection(true);
          } else {
            setUserMasterSelection(false);
            isMasterSelection.current = false;
          }

        }

        if (jsonDocs.userList.length != 0) {

          if (!isControlClick.isClear) {
            setIsControlClick((prev) => {
              return { ...prev, isSharedUsers: true };
            });
          } else {
            setIsControlClick((prev) => {
              return { ...prev, isClear: false };
            });
          }
          if (iscleared === 1) {
            jsonDocs.userList.map((item, i) => {
              item.selection = false;
            });
          }

          sendDataListToParaent(Userids);
        }
      }
      if (sharingOption === "2" && jsonDocs.userList.length > 0) {
        setRecordsSelectedCount((prev) => {
          return {
            showRecords: true,
            count: jsonDocs.userList.length
          }
        })
      }
      if (selectAccessRef.current.value === "2" && ownerInput === "") {
        const editRecords = jsonDocs.userList.filter((userDetail) => {
          return accessRecords.edit.includes(userDetail.id);
        });
        if (editRecords.length === 0) {
          setNoRecordsFoundUsers(true);
          setUserTotalPagesCount(0);
        }
        //setLstUserDetails(editRecords);
        const totalPages = Math.ceil(editRecords.length / userPageView);
        const startIndex = (0) * userPageView;
        const paginatedRecords = editRecords.slice(startIndex, startIndex + userPageView);

        setLstUserDetails(paginatedRecords);
        setUserTotalPagesCount(totalPages || 1);

      }
      else if (selectAccessRef.current.value === "1" && ownerInput === "") {
        const viewRecords = jsonDocs.userList.filter((userDetail) => {
          return !accessRecords.edit.includes(userDetail.id);
        });
        if (viewRecords.length === 0) {
          setNoRecordsFoundUsers(true);
          setUserTotalPagesCount(0);
        }
        // setLstUserDetails(viewRecords);
        const totalPages = Math.ceil(viewRecords.length / userPageView);
        const startIndex = (0) * userPageView;
        const paginatedRecords = viewRecords.slice(startIndex, startIndex + userPageView);

        setLstUserDetails(paginatedRecords);
        setUserTotalPagesCount(totalPages || 1);
      } else {
        // setLstUserDetails(jsonDocs.userList);
        const totalPages = Math.ceil(jsonDocs.userList.length / userPageView);
        const startIndex = (0) * userPageView;
        const paginatedRecords = jsonDocs.userList.slice(startIndex, startIndex + userPageView);

        setLstUserDetails(paginatedRecords);
        setUserTotalPagesCount(totalPages);
      }
      const existingUserIds = new Set(userList.current.flat().map(user => user.id));
      const newUsers = jsonDocs.userList.filter(user => !existingUserIds.has(user.id));
      if (newUsers.length > 0) {
        userList.current = [...userList.current, ...newUsers];
      }
      setOpen(false);
    } catch (error) {
      setOpen(false);
      setOpenLoaderSearch(false);
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FailedtoLoadDoc + ".");
      setAlertType("warning");
      return;
    }
  };

  useEffect(() => {
    if (sharingOption === "2" && lstUserDetails.length > 0) {
      itemsCheckRef.current.map((item) => {
        if (item != null) {
          item.checked = true;
          item.disabled = true;
        }
      });
      selectAllUserRef.current.checked = true;
      selectAllUserRef.current.disabled = true;
    }

    if (accessRecords.edit.length === 0 && accessRecords.view.length === 0) {
      return;
    }
    if (lstUserDetails.length > 0) {
      lstUserDetails.map((item, index) => {
        if (accessRecords.edit.includes(item.id)) {
          if (editRef.current[index]) {
            editRef.current[index].checked = true;
            viewRef.current[index].checked = false;
          }
        } else {
          if (editRef.current[index]) {
            editRef.current[index].checked = false;
            viewRef.current[index].checked = true;
          }
        }
      })
    }

  }, [lstUserDetails])



  const handleClearRecordCount = () => {
    if (sharingOption === "2") {
      return;
    }
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    setSelectedSearchRecords(() => {
      return [{ page: 0, users: [] }];
    });
    setLstUserDetails((prev) => {
      return prev.map((element) => {
        return { ...element, selection: false };
      });
    });
    setUserMasterSelection(false);
    isRpdSelectedTextClear.current = true;


    isrPDSharedFolderDataSharedUserIds.current = false;
    rPDSharedFolderDataSharedUserIds.current = [];
  };

  function handlerUserMasterSelection(event) {
    setLstUserDetails(
      lstUserDetails.map((element) => {
        return { ...element, selection: event.target.checked };
      })
    );
    isMasterSelection.current = event.target.checked;
    itemsCheckRef.current = itemsCheckRef.current.filter(
      (item) => item != null
    );
    if (!event.target.checked)
      itemsCheckRef.current.map((item) => {
        if (item != null) {
          item.checked = false;
        }
      });
    if (lstUserDetails.length > 0) {
      setUserMasterSelection(event.target.checked);
    } else {
      setUserMasterSelection(false);
    }
    selectionOfRecords();
  }

  const onUserPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    userCurrentPagevalue = pageNumber;
    userCurrentPageViewCount = userPageView;
    if (pageNumber === usertotalPagesCount) {
      setisUserDisableNext(true);
      setisUserDisablePrev(false);
    } else if (pageNumber === 1) {
      setisUserDisablePrev(true);
      setisUserDisableNext(false);
    } else {
      setisUserDisablePrev(false);
      setisUserDisableNext(false);
    }
    // GetUserList();
    setPagination(pageNumber);

  };
  const onUserPrevClick = () => {
    setCurrentPage(currentPage - 1);
    userCurrentPagevalue = currentPage - 1;
    userCurrentPageViewCount = userPageView;
    if (currentPage === 1) {
      setisUserDisablePrev(true);
      setisUserDisableNext(false);
    } else {
      setisUserDisablePrev(false);
      setisUserDisableNext(false);
    }
    setPagination(currentPage - 1);
    //GetUserList();
  };

  const onUserNextClick = () => {
    setCurrentPage(currentPage + 1);
    userCurrentPagevalue = currentPage + 1;
    userCurrentPageViewCount = userPageView;
    if (currentPage === usertotalPagesCount) {
      setisUserDisableNext(true);
      setisUserDisablePrev(false);
    } else {
      setisUserDisablePrev(false);
      setisUserDisableNext(false);
    }
    //GetUserList();
    setPagination(currentPage + 1);
  };
  const setUserpageViewDrp = (e, folderview = 0) => {
    userCurrentPageViewCount = e;
    setCurrentPage(1);
    userCurrentPagevalue = 1;
    setUserPageView(e);
    setisUserDisableNext(false);
    setisUserDisablePrev(false);
    //GetUserList();
    setPagination(1, e);
  };
  function handlerUserSelection(event, index) {
    isMasterSelection.current = false;
    setLstUserDetails(
      lstUserDetails.map((element, i) => {
        if (index === i) return { ...element, selection: event.target.checked };
        else return { ...element };
      })
    );
    if (
      lstUserDetails.length ===
      lstUserDetails.filter((element) => element.selection === true).length +
      (event.target.checked ? 1 : -1)
    )
      setUserMasterSelection(true);
    else setUserMasterSelection(false);
    selectionOfRecords();
  }

  const selectionOfRecords = () => {
    if (sharingOption === "2") {
      setSelectedSearchRecords((prev) => {
        const existingPage = prev.find((record) => record.page === 0);
        if (existingPage) {
          const userIds = lstUserDetails.map((item) => item.id);
          return prev.map((record) => record.page === 0 ? { ...record, users: [...existingPage.users, ...userIds] } : record)
        }
      })
      return;
    }
    let selectedIds = [];
    let unSelectedIds = [];
    if (isrPDSharedFolderDataSharedUserIds.current) {
      selectedIds = [...rPDSharedFolderDataSharedUserIds.current];
      isrPDSharedFolderDataSharedUserIds.current = false;

    } else {
      if (isMasterSelection.current === true) {
        lstUserDetails.filter((element) => {

          selectedIds.push(element.id);

        });
      } else {
        lstUserDetails.filter((element, i) => {
          if (itemsCheckRef.current[i].checked) {
            selectedIds.push(element.id);
          } else {
            unSelectedIds.push(element.id);

          }
        });
      }
    }
    const filteredSelectedRecords = selectedSearchRecords[0].users.filter(
      (element) => !unSelectedIds.includes(element));

    setSelectedSearchRecords((prev) => {
      const existingPage = prev.find((record) => record.page === 0);
      if (existingPage) {
        const userIds = selectedIds.filter(
          (id) => !existingPage.users.includes(id)
        );

        return prev.map((record) =>
          record.page === 0
            ? {
              ...record,
              users: [...filteredSelectedRecords, ...userIds],
            }
            : record
        );
      }
    });
  };

  const setPagination = (pageNumber, pageView = userPageView) => {
    pageView = parseInt(pageView);
    if (selectAccessRef.current.value === "2" && ownerInput === "") {
      const editRecords = userList.current.filter((userDetail) => {
        return accessRecords.edit.includes(userDetail.id);
      });
      if (editRecords.length === 0) {
        setNoRecordsFoundUsers(true);
        setUserTotalPagesCount(0);
      }
      const totalPages = Math.ceil(editRecords.length / pageView);
      const startIndex = (pageNumber - 1) * pageView;
      let paginatedRecords = editRecords.slice(
        startIndex,
        startIndex + pageView
      );
      if (ownerInput !== "") {
        paginatedRecords = paginatedRecords.filter((user) => {
          return JSON.stringify(user.email).toLowerCase().includes(ownerInput);
        });
      }
      setLstUserDetails(paginatedRecords);
      if (paginatedRecords.length === 0) {
        setNoRecordsFoundUsers(true);
        setUserTotalPagesCount(0);
        return;
      }

      setUserTotalPagesCount(totalPages || 1);
      if (totalPages > 1) {
        setisUserDisableNext(false);
      }

    }
    else if (selectAccessRef.current.value === "1" && ownerInput === "") {
      const viewRecords = userList.current.filter((userDetail) => {
        return !accessRecords.edit.includes(userDetail.id);
      });
      if (viewRecords.length === 0) {
        setNoRecordsFoundUsers(true);
        setUserTotalPagesCount(0);
      }

      const totalPages = Math.ceil(viewRecords.length / pageView);
      const startIndex = (pageNumber - 1) * pageView;
      let paginatedRecords = viewRecords.slice(
        startIndex,
        startIndex + pageView
      );
      if (ownerInput !== "") {
        paginatedRecords = paginatedRecords.filter((user) => {
          return JSON.stringify(user.email).toLowerCase().includes(ownerInput);
        });
      }
      setLstUserDetails(paginatedRecords);
      if (paginatedRecords.length === 0) {
        setNoRecordsFoundUsers(true);
        setUserTotalPagesCount(0);
        return;
      }


      setUserTotalPagesCount(totalPages || 1);
      if (totalPages > 1) {
        setisUserDisableNext(false);
      }

    }
    else {
      const totalPages = Math.ceil(userList.current.length / pageView);
      const startIndex = (pageNumber - 1) * pageView;
      let paginatedRecords = userList.current.slice(
        startIndex,
        startIndex + pageView
      );
      if (ownerInput !== "") {
        paginatedRecords = paginatedRecords.filter((user) => {
          return JSON.stringify(user.email).toLowerCase().includes(ownerInput);
        });
      }

      setLstUserDetails(paginatedRecords);
      if (paginatedRecords.length === 0) {
        setNoRecordsFoundUsers(true);
        setUserTotalPagesCount(0);
        return;
      }


      setUserTotalPagesCount(totalPages);
      if (totalPages > 1) {
        setisUserDisableNext(false);
      }

    }
    setCurrentPage(pageNumber);
  }



  const filterUniqueUsers = (userList, existingUsers, filterFn) => {
    const filteredUsers = userList.filter(filterFn);
    const existingUserIds = new Set(existingUsers.map(user => user.id));
    return filteredUsers.filter(user => !existingUserIds.has(user.id));
  };

  function SearchUserData() {
    setPagination(1);
    //GetUserList();
    setUserMasterSelection(false);
    userCurrentPageViewCount = userPageView;
    setCurrentPage(1);
    userCurrentPagevalue = 1;
  }

  function RetainUserList(iscleared) {
    setIsControlClick(() => {
      return { isClear: true, isSearchOrRefresh: false };
    });
    setSelectedSearchRecords(() => {
      return [{ page: 0, users: [] }];
    });
    setRecordsSelectedCount(() => {
      return { showRecords: false, count: 0 };
    });
    setOwnerInput("");
    setCurrentPage(1);
    setUserPageView(25);
    userCurrentPagevalue = 1;
    //setisSearchClicked(0);
    userCurrentPageViewCount = 25;

    var litems = lstUserDetails.filter((element) => element.selection === true);
    for (const item of litems) {
      item.selection = false;
    }
    selectAccessRef.current.value = "0";
    setUserMasterSelection(false);
    isRpdSelectedTextClear.current = true;
    isrPDSharedFolderDataSharedUserIds.current = false;
    rPDSharedFolderDataSharedUserIds.current = [];

  }

  function handleSelectUserData(event) {
    var sharedUserIds = [];
    try {
      if (selectedSearchRecords[0].users.length > 0) {

        let allUsers = selectedSearchRecords.reduce((accumulator, item) => {
          return accumulator.concat(item.users);
        }, []);

        console.log(allUsers);

        allUsers.map((item) => {
          sharedUserIds.push({
            SharedUserId: item,
            isEdit: accessRecords.edit.includes(item) ? '1' : '0'
          });
        });
        sendDataToParent(sharedUserIds);
      } else {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_PleaseSelectAtleastOneUser
        );
        setAlertType("warning");
      }
    } catch (error) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FailedtoLoadDoc + ".");
      setAlertType("warning");
      return;
    }
  }

  function onCancelHandler() {

    if (sharingOption === "2") {
      handleSelectUserData();
    } else {
      onCancel();
    }

  }




  function onViewAccessChangeHandler(e, index) {
    editRef.current[index].checked = false;
    setAccessRecords((prev) => {
      return {
        ...prev,
        view: [...prev.view, lstUserDetails[index].id],
        edit: prev.edit.filter((item) => item !== lstUserDetails[index].id),
      };
    })
  }

  function onEditAccessChangeHandler(e, index) {
    viewRef.current[index].checked = false;
    setAccessRecords((prev) => {
      return {
        ...prev,
        edit: [...prev.edit, lstUserDetails[index].id],
        view: prev.view.filter((item) => item !== lstUserDetails[index].id),
      };
    })
  }

  return (
    isOpen && (
      <>
        {openLoader ? (
          <LoadingSpinner
            className={openLoaderSearch ? "backgroundTransprent" : undefined}
          />
        ) : null}

        <Alert
          alertType={alertType}
          alertMsg={alertMsg}
          setAlertMsg={setAlertMsg}
          setAlertType={setAlertType}
          className="alerthist"
        ></Alert>
        <div
          className="modalCus UserListPopUp"
          id="myModal"
          style={{ display: "block", backgroundColor: "#8080801c" }}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content card-body pt-0">
              <div className="modal-header pb-1 ps-1">
                <h4
                  className="d-flex align-items-center text-danger fw-bold "
                  htmlFor=""
                >
                  {selectedLanguage.LstLanguageCodes.UI_SelectUsers}
                </h4>
              </div>
              <div className="row d-flex align-items-center flex-wrap justify-content-between my-3 pt-2 mx-1">
                <div className=" d-flex " style={{ marginTop: "-10px" }}>
                  <input className="custom-inputBorder"
                    type="text"
                    name="ownerInput"
                    autoComplete="none"
                    value={ownerInput}
                    title={ownerInput}
                    placeholder={
                      selectedLanguage.LstLanguageCodes.UI_NameOrEmailSearch
                    }
                    style={{
                      width: recordsSelectedCount.showRecords
                        ? "300px"
                        : "350px",
                      marginLeft: "-20px",
                      // fontWeight: "500",
                    }}
                    onChange={(e) => setOwnerInput(e.target.value)}
                  />
                  <div className="SearchFiels-select">
                    <select
                      className="form-select form-control res-controls custom-inputBorder access-request ms-3"
                      name="documentIdInput" ref={selectAccessRef}>
                      <option value="0">{selectedLanguage.LstLanguageCodes.UI_SelectAccess}</option>
                      <option value="1">{selectedLanguage.LstLanguageCodes.UI_View}</option>
                      <option value="2">{selectedLanguage.LstLanguageCodes.UI_Edit}</option>
                    </select>
                  </div>
                  <div style={{ display: "flex", marginLeft: "25px" }}>
                    <span
                      className="material-icons searchHistory"
                      onClick={SearchUserData}
                      style={{ cursor: "pointer" }}
                    >
                      search
                    </span>
                    <span
                      className="material-icons cancelHistory"
                      id="clearFiltersButton"
                      onClick={(e) => RetainUserList(1)}
                      style={{ cursor: "pointer" }}
                    >
                      block
                    </span>
                  </div>
                  {recordsSelectedCount.showRecords && (
                    <div className="cancelOwnerTextSelectionCount">
                      {recordsSelectedCount.showRecords && (
                        <span
                          title={`${recordsSelectedCount.count} ${recordsSelectedCount.count === 1 ? "User" : "Users"
                            } selected`}
                        >
                          {`${recordsSelectedCount.count} ${recordsSelectedCount.count === 1 ? "User" : "Users"
                            } selected`}
                        </span>
                      )}

                      {recordsSelectedCount.showRecords && (
                        <AiOutlineCloseCircle
                          onClick={handleClearRecordCount}
                          className="cancelsmaliconSelectionCount"
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div
                  className="card-body-new pt-0"
                  style={{ height: "350px", overflow: "hidden auto" }}
                >
                  <div className="table-responsive res-card">
                    <table
                      className="fold-table table tablelayout "
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead className="bg-lightblue">
                        <tr className="">
                          <th className="w-5p">
                            <div className="checkbox ms-22">
                              <label className="p-0 mb-0">
                                <input
                                  type="checkbox"
                                  value={userMasterSelection}
                                  checked={userMasterSelection}
                                  ref={selectAllUserRef}
                                  onChange={(e) =>
                                    handlerUserMasterSelection(e)
                                  }
                                />
                                <span className="cr">
                                  <i className="cr-icon material-icons">
                                    check
                                  </i>
                                </span>
                              </label>
                            </div>
                          </th>
                          <th className="w-15p">
                            <span className="">
                              {selectedLanguage.LstLanguageCodes.UI_Name}
                            </span>
                          </th>
                          <th className="w-15p">
                            <span className="">
                              {selectedLanguage.LstLanguageCodes.UI_Email}
                            </span>
                          </th>
                          <th className="w-15p">
                            <span className="">
                              {selectedLanguage.LstLanguageCodes.UI_Company}
                            </span>
                          </th>
                          <th className="w-20p text-center" colSpan={2}>
                            <span>
                              {selectedLanguage.LstLanguageCodes.UI_Access}
                            </span>
                          </th>

                        </tr>
                      </thead>
                      <tbody>
                        {/* <!-------- First one ---------> */}

                        {lstUserDetails.length > 0 &&
                          lstUserDetails.map((item, i) => (
                            <tr
                              className="borderrow" key={i}
                              // onClick={(e) =>
                              //   rowclick(e, item.ownerid)
                              // }
                              // ref={(el) => (trRef.current[i] = el)}
                              id={"trMain" + i}
                            >
                              <td
                                className="w-5p text-start"
                                style={{ display: "" }}
                              >
                                <div
                                  className="checkbox mt-n5p marginTop8"
                                  style={{ marginLeft: "27px" }}
                                >
                                  <label className="p-0 mb-0">
                                    <input
                                      type="checkbox"
                                      value={item.selection}
                                      onChange={(e) =>
                                        handlerUserSelection(e, i)
                                      }
                                      checked={item.selection}
                                      ref={(el) =>
                                        (itemsCheckRef.current[i] = el)
                                      }
                                    />
                                    <span className="cr">
                                      <i className="cr-icon material-icons">
                                        check
                                      </i>
                                    </span>
                                  </label>
                                </div>
                              </td>
                              <td
                                className="w-15p text-start"
                                title={
                                  item.firstName != "" &&
                                    item.lastName != ""
                                    ? item.firstName + " " + item.lastName
                                    : item.firstName == ""
                                      ? item.lastName
                                      : item.firstName
                                }
                                style={borderleft}
                              >
                                <span className="Wordbreak">
                                  {item.firstName != "" &&
                                    item.lastName != ""
                                    ? item.firstName + " " + item.lastName
                                    : item.firstName == ""
                                      ? item.lastName
                                      : item.firstName}
                                </span>
                              </td>
                              <td
                                className="text-start w-15p"
                                title={item.email}
                                style={borderleft}
                              >
                                <div className="d-flex flex-wrap textwrap">
                                  {item.email}
                                </div>
                              </td>
                              <td
                                className="text-start w-15p"
                                title={item.companyName}
                                style={borderleft}
                              >
                                <div
                                  className="d-flex flex-wrap Wordbreak"
                                // title={item.documentOptions.subject}
                                >
                                  <p className="textwrap mb-0">
                                    {item.companyName}
                                  </p>
                                </div>
                              </td>
                              <td
                                className="text-center w-10p"
                                style={borderleft}
                              >
                                <div className="">
                                  <label className="radio1">
                                    <span className={"mr-a-" + selectedLanguage?.Language?.toLowerCase()} >{selectedLanguage.LstLanguageCodes.UI_View}</span>
                                    <input type="radio" name={`access__${i}`}
                                      onChange={(e) =>
                                        onViewAccessChangeHandler(e, i)
                                      }
                                      ref={(el) =>
                                        (viewRef.current[i] = el)
                                      }
                                      defaultChecked={true}
                                    />
                                    <span className="checkmark"></span>
                                  </label>

                                </div>
                              </td>
                              <td
                                className="text-center w-10p"
                                style={borderleft}
                              >
                                <div className="">
                                  <label className="radio1">
                                    <span className={"mr-" + selectedLanguage?.Language?.toLowerCase()} >{selectedLanguage.LstLanguageCodes.UI_Edit}</span>
                                    <input type="radio" name={`access__${i}`}
                                      onChange={(e) =>
                                        onEditAccessChangeHandler(e, i)
                                      }
                                      ref={(el) =>
                                        (editRef.current[i] = el)
                                      }
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                </div>
                              </td>
                            </tr>
                          ))}
                        {noRecordsFoundUsers && lstUserDetails.length == 0 && (
                          <tr>
                            <td colSpan={8} style={{ textAlign: "center" }}>
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_NoRecordsFound
                              }
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                  </div>
                  <div className="d-flex align-items-center justify-content-between me-3">
                    <div className="w-auto ms-2 mt-n3 d-flex align-items-center">
                      <label
                        htmlFor="userpageView"
                        className="text-nowrap font-w600 control me-3"
                      >
                        {selectedLanguage.LstLanguageCodes.UI_pageView}:
                      </label>
                      <select
                        className="form-select form-control files-folder-select res-controls custom-inputBorder"
                        name="ownerInput"
                        value={userPageView}
                        onChange={(e) => setUserpageViewDrp(e.target.value)}
                      >
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                    </div>
                    {usertotalPagesCount > 1 ? (
                      <Pagination
                        {...paginationAttributes}
                        onPrevClick={onUserPrevClick}
                        onNextClick={onUserNextClick}
                        onPageChange={onUserPageChange}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>



              <div
                className="d-flex align-items-center justify-content-end mb-1 mt-3"
                style={{ marginTop: "8px" }}
              >

                <button
                  type="button"
                  className="btn btn-danger px-4 me-1"
                  data-bs-dismiss="modal"
                  onClick={onCancelHandler}
                >
                  {selectedLanguage.LstLanguageCodes.UI_Cancel}
                </button>
                <button
                  type="button"
                  className="btn btn-primary px-4 ms-3"
                  onClick={(e) => handleSelectUserData(e)}
                >
                  {selectedLanguage.LstLanguageCodes.UI_Confirm}
                </button>
              </div>

            </div>
          </div>
        </div>
      </>
    )
  );
}
export default UserListPopup;
